"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserStorageKeyStore = void 0;
var getKeyMetadata_1 = require("../Helpers/getKeyMetadata");
var BrowserStorageFacade_1 = require("./BrowserStorageFacade");
/**
 * KeyStore for Chrome and Firefox browser storage API:
 * https://developer.chrome.com/docs/extensions/reference/storage/.
 * Once instantiated and configured, pass it to the `KeyManager` contructor to
 * handle the storage of encrypted keys.
 * ```js
 * const browserKeyStore = new KeyManagerPlugins.BrowserStorageKeyStore();
 * browserKeyStore.configure({ storage: chrome.storage.local });
 * const keyManager = new KeyManager({
 *     keyStore: browserKeyStore
 *  });
 * ```
 */
var BrowserStorageKeyStore = /** @class */ (function () {
    function BrowserStorageKeyStore() {
        this.name = "BrowserStorageKeyStore";
        this.keyStore = new BrowserStorageFacade_1.BrowserStorageFacade();
    }
    /**
     * The configuration is where the storage engine is set up and configured.
     * It must follow the Storage interface :
     * https://developer.chrome.com/docs/extensions/reference/storage/).
     * This is mostly for use with Chrome and Firefox storage in addition to
     * libraries that shim this (for ex: webextension-polyfill)
     * @param {BrowserStorageConfigParams} params A configuration object.
     * @param {Storage} params.storage The Storage instance. Required.
     * @param {string} [params.prefix] The prefix for the names in the storage.
     * @returns {Promise} resolved data
     */
    BrowserStorageKeyStore.prototype.configure = function (params) {
        try {
            this.keyStore.configure(params);
            return Promise.resolve();
        }
        catch (e) {
            return Promise.reject(e);
        }
    };
    BrowserStorageKeyStore.prototype.storeKeys = function (keys) {
        return __awaiter(this, void 0, void 0, function () {
            var usedKeys, _i, keys_1, encryptedKey, hasKey, keysMetadata, _a, keys_2, encryptedKey;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        usedKeys = [];
                        _i = 0, keys_1 = keys;
                        _b.label = 1;
                    case 1:
                        if (!(_i < keys_1.length)) return [3 /*break*/, 4];
                        encryptedKey = keys_1[_i];
                        return [4 /*yield*/, this.keyStore.hasKey(encryptedKey.id)];
                    case 2:
                        hasKey = _b.sent();
                        if (hasKey) {
                            usedKeys.push(encryptedKey);
                        }
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4:
                        if (usedKeys.length) {
                            return [2 /*return*/, Promise.reject("Some keys were already stored in the keystore: ".concat(usedKeys
                                    .map(function (k) { return k.id; })
                                    .join(", ")))];
                        }
                        keysMetadata = [];
                        for (_a = 0, keys_2 = keys; _a < keys_2.length; _a++) {
                            encryptedKey = keys_2[_a];
                            this.keyStore.setKey(encryptedKey.id, encryptedKey);
                            keysMetadata.push((0, getKeyMetadata_1.getKeyMetadata)(encryptedKey));
                        }
                        return [2 /*return*/, Promise.resolve(keysMetadata)];
                }
            });
        });
    };
    BrowserStorageKeyStore.prototype.updateKeys = function (keys) {
        var _this = this;
        // we can't update keys if they're already stored
        var invalidKeys = keys.filter(function (encryptedKey) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.keyStore.hasKey(encryptedKey.id)];
                case 1: return [2 /*return*/, !(_a.sent())];
            }
        }); }); });
        if (invalidKeys.length) {
            return Promise.reject("Some keys couldn't be found in the keystore: ".concat(invalidKeys
                .map(function (k) { return k.id; })
                .join(", ")));
        }
        var keysMetadata = keys.map(function (encryptedKey) {
            _this.keyStore.setKey(encryptedKey.id, encryptedKey);
            return (0, getKeyMetadata_1.getKeyMetadata)(encryptedKey);
        });
        return Promise.resolve(keysMetadata);
    };
    BrowserStorageKeyStore.prototype.loadKey = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var key;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.keyStore.getKey(id)];
                    case 1:
                        key = _a.sent();
                        if (!key) {
                            return [2 /*return*/, Promise.reject(id)];
                        }
                        return [2 /*return*/, Promise.resolve(key)];
                }
            });
        });
    };
    BrowserStorageKeyStore.prototype.removeKey = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var key, metadata;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.keyStore.hasKey(id)) {
                            return [2 /*return*/, Promise.reject(id)];
                        }
                        return [4 /*yield*/, this.keyStore.getKey(id)];
                    case 1:
                        key = _a.sent();
                        metadata = (0, getKeyMetadata_1.getKeyMetadata)(key);
                        this.keyStore.removeKey(id);
                        return [2 /*return*/, Promise.resolve(metadata)];
                }
            });
        });
    };
    BrowserStorageKeyStore.prototype.loadAllKeys = function () {
        return __awaiter(this, void 0, void 0, function () {
            var keys;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.keyStore.getAllKeys()];
                    case 1:
                        keys = _a.sent();
                        return [2 /*return*/, Promise.resolve(keys)];
                }
            });
        });
    };
    return BrowserStorageKeyStore;
}());
exports.BrowserStorageKeyStore = BrowserStorageKeyStore;
